import { render, staticRenderFns } from "./TrendingTopicsWidget.vue?vue&type=template&id=e320e61a&scoped=true&"
import script from "./TrendingTopicsWidget.vue?vue&type=script&lang=js&"
export * from "./TrendingTopicsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TrendingTopicsWidget.vue?vue&type=style&index=0&id=e320e61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e320e61a",
  null
  
)

export default component.exports